var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKitchen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_24657",
    "data-name": "Group 24657",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.43,
    height: 19.917,
    viewBox: "0 0 21.43 19.917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6063",
    "data-name": "Rectangle 6063",
    width: 21.43,
    height: 19.917,
    transform: "translate(0 0)",
    fill: "#0b2055"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24656",
    "data-name": "Group 24656",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12903",
    "data-name": "Path 12903",
    d: "M13.971,6.144a.5.5,0,0,0,.707,0L18.821,2a.5.5,0,1,0-.707-.707L13.971,5.437a.5.5,0,0,0,0,.707",
    fill: "#0b2055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12904",
    "data-name": "Path 12904",
    d: "M15.286,7.459a.5.5,0,0,0,.707,0l4.143-4.143a.5.5,0,0,0-.707-.707L15.286,6.752a.5.5,0,0,0,0,.707",
    fill: "#0b2055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12905",
    "data-name": "Path 12905",
    d: "M4.312,18.548a1.011,1.011,0,0,1-.708.338h0a1.029,1.029,0,0,1-.722-.336,1.028,1.028,0,0,1-.335-.725,1.012,1.012,0,0,1,.341-.711c.377-.376,3.507-3.179,5.858-5.264l-.1-.1H7.353C5.109,13.741,2.532,16.053,2.181,16.4a1.983,1.983,0,0,0-.637,1.417,2.028,2.028,0,0,0,.628,1.436,2.03,2.03,0,0,0,1.429.629h.008a1.98,1.98,0,0,0,1.413-.634c.381-.381,3.107-3.424,5.2-5.786l-.68-.741c-2.084,2.349-4.861,5.451-5.233,5.823",
    fill: "#0b2055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12906",
    "data-name": "Path 12906",
    d: "M12.133,6.946A2.471,2.471,0,0,1,13.2,4.61c1-.884,4.331-3.865,4.331-3.865L16.86,0s-3.328,2.978-4.326,3.861a3.435,3.435,0,0,0-1.4,3.091A2.989,2.989,0,0,1,10.6,8.793l.7.7a3.937,3.937,0,0,0,.832-2.551",
    fill: "#0b2055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12907",
    "data-name": "Path 12907",
    d: "M14.478,10.3a3.437,3.437,0,0,0,3.091-1.4c.883-1,3.861-4.326,3.861-4.326L20.685,3.9S17.7,7.234,16.82,8.234A2.451,2.451,0,0,1,14.54,9.3h-.088a3.925,3.925,0,0,0-2.519.832l.7.7a2.806,2.806,0,0,1,1.845-.533",
    fill: "#0b2055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12908",
    "data-name": "Path 12908",
    d: "M10.6,10.21l.62.62.209-.238a3.779,3.779,0,0,1,.5-.463L11.3,9.5a3.763,3.763,0,0,1-.462.5l-.239.21",
    fill: "#0b2055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12909",
    "data-name": "Path 12909",
    d: "M12.633,10.83a3.019,3.019,0,0,0-.452.42l-.253.289,5.8,5.8a.855.855,0,0,1-.065,1.284.894.894,0,0,1-.7.293.977.977,0,0,1-.636-.278l-5.434-5.925-.666.752L15.6,19.331a1.97,1.97,0,0,0,1.322.585h.068a1.931,1.931,0,0,0,1.372-.586,1.849,1.849,0,0,0,.065-2.7Z",
    fill: "#0b2055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12910",
    "data-name": "Path 12910",
    d: "M7.041,10.746c-.7-.807-3.651-4.216-4.625-5.358C.942,3.658.744,1.73,1.26,1.214a.3.3,0,0,1,.179-.1c.048-.01.1.025.15.079L9.891,9.5l.29-.254a2.774,2.774,0,0,0,.416-.454L2.3.485a1.2,1.2,0,0,0-.9-.371A1.267,1.267,0,0,0,.553.507C-.5,1.563,0,4.095,1.655,6.036c1.109,1.3,4.78,5.538,4.78,5.538a.5.5,0,0,0,.377.172h.541l1.127-1Z",
    fill: "#0b2055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12911",
    "data-name": "Path 12911",
    d: "M8.743,11.85l.8.875.666-.752-.721-.786-.748.663",
    fill: "#0b2055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12912",
    "data-name": "Path 12912",
    d: "M9.891,9.5l.708.709.24-.21a3.823,3.823,0,0,0,.461-.5l-.7-.7a2.783,2.783,0,0,1-.417.455L9.891,9.5",
    fill: "#0b2055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12913",
    "data-name": "Path 12913",
    d: "M8.743,11.85l.748-.663-.255-.278a.5.5,0,0,0-.368-.163H8.48l-1.127,1H8.648Z",
    fill: "#0b2055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12914",
    "data-name": "Path 12914",
    d: "M10.212,11.973l-.667.752.68.741c.232-.26.456-.513.667-.752Z",
    fill: "#0b2055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12915",
    "data-name": "Path 12915",
    d: "M11.219,10.83l.708.709.254-.289a2.868,2.868,0,0,1,.451-.42l-.7-.7a3.771,3.771,0,0,0-.5.462c-.061.071-.137.157-.209.239",
    fill: "#0b2055"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchen);
export default __webpack_public_path__ + "static/media/kitchen.51d1edd612491f762347cfd1b63b9eec.svg";
export { ForwardRef as ReactComponent };